module.exports = __webpack_public_path__ + "img/Mask_2.9c909b56.png";